import { render, staticRenderFns } from "./footercommon.vue?vue&type=template&id=a9b3e372"
import script from "./footercommon.vue?vue&type=script&lang=js"
export * from "./footercommon.vue?vue&type=script&lang=js"
import style0 from "./footercommon.vue?vue&type=style&index=0&id=a9b3e372&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports